import type {Elements, IContentItem} from '@kontent-ai/delivery-sdk'
import {clsx} from 'clsx'
import {Column as ClColumn} from '@/products/flexible-web-toolkit/layout/column'
import type {Block} from '@/services/kontent-ai/types'
import type {BgColor} from '@/products/flexible-web-toolkit/layout/layout-common-types'
import {getContainerClass, getBrandColor} from '../helpers'
import {spacingPadding} from '../../styles'

export type ColumnContentItem = IContentItem<{
	items: Elements.LinkedItemsElement
	layout: Elements.MultipleChoiceElement
	snippetContainerResize: Elements.MultipleChoiceElement
	snippetSpacingSpacing: Elements.MultipleChoiceElement
	snippetLayoutBackgroundColorColor: Elements.MultipleChoiceElement
}>

export const ColumnBlock: Block<ColumnContentItem> = ({
	block,
	BlockMapper,
	page,
	...context
}) => {
	const containerSizeOption =
		block.elements.snippetContainerResize[0]?.codename

	const containerSize = containerSizeOption
		? getContainerClass(containerSizeOption, 'container-wide')
		: 'container-wide'

	const componentSpacing = (() => {
		switch (block.elements.snippetSpacingSpacing[0]?.codename) {
			case 'default': {
				return spacingPadding.default
			}
			case 'top': {
				return spacingPadding.top
			}
			case 'bottom': {
				return spacingPadding.bottom
			}
			case 'none': {
				return spacingPadding.none
			}
			default: {
				return spacingPadding.none
			}
		}
	})()

	const pageConfig = page.elements.config[0]
	const brand = pageConfig ? getBrandColor(pageConfig) : null

	const snippetColor: BgColor = (() => {
		const codename =
			block.elements.snippetLayoutBackgroundColorColor[0]?.codename
		if (codename) {
			return codename as BgColor
		}
		return 'none'
	})()

	const liteBackground =
		snippetColor === 'brand'
			? `!bg-${brand}-light bg-default-light-background`
			: ''

	return (
		<ClColumn
			bgColor={snippetColor}
			className={clsx(
				componentSpacing,
				liteBackground,
				block.system.type
			)}
			containerClassName={containerSize}
		>
			<div className="w-[inherit]">
				{block.elements.items.map((item) => (
					<BlockMapper
						blocks={[item]}
						key={item.system.id}
						page={page}
						{...context}
					/>
				))}
			</div>
		</ClColumn>
	)
}
